import React, { useState } from 'react';
import axios from 'axios';

const RegisterClientModal = ({ onClose, onSwitchToLogin, visible }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: ''
  });
  const [message, setMessage] = useState('');

  if (!visible) return null;

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    const clientKey = localStorage.getItem("selectedClient");

    try {
      // ✅ Récupération du token CSRF
      const csrfRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/csrf-token`, {
        withCredentials: true,
        headers: {
          'Cache-Control': 'no-cache',
          'x-client-key': clientKey || ''
        }
      });
      const csrfToken = csrfRes.data.csrfToken;

      // ✅ Requête d'inscription
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users/register`,
        formData,
        {
          headers: {
            'X-CSRF-Token': csrfToken,
            'Content-Type': 'application/json',
            'x-client-key': clientKey || ''
          },
          withCredentials: true,
        }
      );

      console.log('✅ Inscription réussie :', res.data);
      setMessage('✅ Inscription réussie !');

      setTimeout(() => {
        onClose();
        onSwitchToLogin();
      }, 1000);

    } catch (err) {
      console.error('❌ Erreur inscription client :', err.response || err);
      setMessage('❌ Erreur : ' + (err.response?.data?.message || 'Erreur inconnue.'));
    }
  };

  return (
    <div className="theme6-modal-overlay active">
      <div className="theme6-modal">
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2>Créer un compte</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Nom"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Adresse email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Téléphone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Mot de passe"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="submit">S'inscrire</button>
        </form>
        {message && <p className="auth-message">{message}</p>}
        <p className="auth-link">
          Déjà inscrit ?{' '}
          <button
            type="button"
            onClick={onSwitchToLogin}
            className="btn-link"
            style={{
              border: 'none',
              background: 'none',
              color: 'var(--theme6-primary)',
              cursor: 'pointer',
              padding: 0
            }}
          >
            Se connecter
          </button>
        </p>
      </div>
    </div>
  );
};

export default RegisterClientModal;
